import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Locations from "../pages/locations/page";
import Seminars from "../pages/seminars/page";
import Portfolio from "../pages/portfolio/page";
import About from "../pages/about/page";
import Process from "../pages/process/page";
import Contact from "../pages/contact/page";
import Technology from "../pages/technology/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/locations",
        element: <Locations />,
      },
      {
        path: "/seminars",
        element: <Seminars />,
      },
      {
        path: "/portfolio",
        element: <Portfolio />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/process",
        element: <Process />,
      },
      {
        path: "/technology",
        element: <Technology />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;